import { cache } from 'react';
import { Product } from '../types/Header';
import { proxifyDictionaryImages } from './proxifyImageUrl';

export const fetchProducts = cache(async (page?: number, searchQuery?: string, url?: string): Promise<Product[]> => {
  try {
    const fetchAllProducts = !page && !searchQuery;
    const response = fetchAllProducts
      ? await fetch(`${url ?? ''}/api/products`)
      : await fetch(`${url ?? ''}/api/products?page=${page}&query=${encodeURIComponent(searchQuery ?? '')}`);

    if (!response.ok) {
      console.error(response);
      return [];

    }
    const res = await response.json();
    return proxifyDictionaryImages(res.products)
  } catch (error) {
    console.error(error);
    return [];
  }
})
